module.exports = __webpack_public_path__ + "static/media/xTETU.687d18ee.svg";